import * as React from 'react';
import clx from 'classnames';
import { Col, Typography, Space, Divider } from 'antd';
const { Title } = Typography;
import { LabeledDate } from 'client/ui/display/date/LabeledDate';
import { IProcedure } from 'common/schema/Procedure';
import { ProcedureSummaryTitle } from './ProcedureSummaryTitle';
import { PageSecondaryColumn } from 'client/ui/layout/page/PageSecondaryColumn';
import { ResponsiveHide } from 'client/ui/responsive/ResponsiveHide';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';
import { Link } from 'react-router-dom';
import { ProcedureLinkText } from 'client/ui/naming/ProcedureLinkText';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';

export interface ProcedureFormSummaryColumnProps {
  procedure: IProcedure;
  children: React.ReactNode;
  isPreview?: boolean;
}

/**
 * Colonna di Sommario e Azioni di una domanda (colonna destra)
 * che include il sommario della domanda per il cittadino
 * ed è il contenitore dei pulsanti per la registrazione e navigazione
 *
 * Questo elemento è condiviso anche con la pagina di Anteprima lato Admin
 */
export function ProcedureFormSummaryColumn(
  props: ProcedureFormSummaryColumnProps
) {
  const { procedure, isPreview } = props;

  return (
    <PageSecondaryColumn orderMobile={3}>
      <ResponsiveHide desktopOnly>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          {/* <ProcedureSummaryTitle children={procedure.title} /> */}
          <LabeledDate
            label="Scadenza"
            date={ProcedureLogic.getRenderableDateWith24Hour(
              procedure.expiresAt
            )}
          />
          <Link
            to={
              isPreview
                ? `/admin/procedures/preview/${procedure.id}`
                : `/domande/${procedure.id}`
            }
          >
            {ProcedureLinkText}
          </Link>
          {/* <Link to={`/istanze/${procedure.id}/faq`}>Vai alle Faq</Link> */}
          <Divider />
        </Space>
      </ResponsiveHide>
      <VerticalSpace />
      {props.children}
    </PageSecondaryColumn>
  );
}
